<template>
  <div class="mt-16 xl:mt-0">
    <div class="flex justify-between items-center">
      <h1
        class="text-xl md:text-2xl font-semibold text-slate-900 dark:text-white"
      >
        البلديات
      </h1>

      <router-link
        title="إضافة"
        :to="{ name: 'addMunicipal' }"
        class="w-28 md:w-40 text-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        إضافة +
      </router-link>
    </div>

    <div class="mt-4 w-full relative">
      <div class="h-8 w-full flex items-center">
        <button
          @click="toggle_filter()"
          class="flex items-center hover:text-blue-600 cursor-pointer w-full"
        >
          <svg
            class="h-6 w-6 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
          >
            <path
              d="M2 7h.142a3.981 3.981 0 0 0 7.716 0H30a1 1 0 0 0 0-2H9.858a3.981 3.981 0 0 0-7.716 0H2a1 1 0 0 0 0 2zm4-3a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm24 11h-.142a3.981 3.981 0 0 0-7.716 0H2a1 1 0 0 0 0 2h20.142a3.981 3.981 0 0 0 7.716 0H30a1 1 0 0 0 0-2zm-4 3a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm4 7H19.858a3.981 3.981 0 0 0-7.716 0H2a1 1 0 0 0 0 2h10.142a3.981 3.981 0 0 0 7.716 0H30a1 1 0 0 0 0-2zm-14 3a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
            />
          </svg>
          <span class="mr-2"> فرز </span>
        </button>

        <button
          v-if="in_search"
          @click="cancel_filter()"
          class="flex items-center justify-center w-28 md:w-48 text-center py-2 px-6 border border-transparent text-sm font-medium rounded-md text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
        >
          <span class="ml-2"> إلغاء الفرز </span>

          <svg
            class="h-6 w-6 stroke-current"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.6974 6.69598L6.6974 18.696"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.6974 6.69598L18.6974 18.696"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <transition
        enter-active-class="transition ease-in-out duration-200"
        enter-class="transform opacity-0 scale-y-0"
        enter-to-class="transform opacity-100 scale-y-100"
        leave-active-class="transition ease-in-out duration-75"
        leave-class="transform opacity-100 scale-y-100"
        leave-to-class="transform opacity-0 scale-y-0"
      >
        <div
          v-if="filter_box"
          class="absolute z-40 w-full top-8 sm:rounded-b-lg border-t-2 border-gray-700 dark:border-slate-400 bg-gray-300 dark:bg-slate-700 dark:bg-opacity-90 bg-opacity-90 px-4 pt-4 pb-8"
        >
          <div class="grid grid-cols-4 gap-8">
            <div class="input">
              <label for="filter_name" class="block text-sm font-medium">
                اسم المركز
              </label>
              <input
                type="text"
                id="filter_name"
                placeholder="أكتب اسم المركز."
                v-model="filter_name"
                class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>

            <div class="input">
              <label for="municipal_id" class="block text-sm font-medium">
                اختر الامداد الطبي
              </label>
              <select
                id="municipal_id"
                name="municipal_id"
                v-model="filter_medical_suppliers_id"
                class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              >
                <option disabled selected>الامداد الطبي</option>
                <option
                  v-for="medical_supplier in medical_suppliers_data"
                  :key="medical_supplier.id"
                  v-bind:value="medical_supplier.id"
                >
                  {{ medical_supplier.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="text-white w-full md:w-auto flex md:justify-end mt-8">
            <div class="inline w-full md:w-auto cursor-pointer">
              <button
                @click="do_search()"
                type="button"
                class="border border-transparent rounded-md shadow-sm w-full md:w-auto py-2 px-16 inline-flex justify-center text-sm font-medium focus:outline-none bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                بحث
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="py-2 align-middle inline-block min-w-full mt-6">
      <div
        class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
      >
        <table class="min-w-full divide-y divide-gray-200">
          <div
            class="w-full flex bg-gray-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 text-xs font-medium tracking-wider text-right"
          >
            <div scope="col" class="w-1/12 px-6 py-3 hidden lg:block">
              الرقم
            </div>
            <div scope="col" class="w-7/12 md:w-3/12 px-6 py-3">الاسم</div>
            <div scope="col" class="md:w-2/12 px-6 py-3 hidden md:block">
              العنوان
            </div>

            <div scope="col" class="md:w-2/12 px-6 py-3 hidden md:block">
              عنوان المخزن
            </div>

            <div scope="col" class="md:w-2/12 px-6 py-3 hidden md:block">
              الامداد الطبي
            </div>

            <div scope="col" class="w-5/12 md:w-3/12 px-6 py-3">الإجراءات</div>
          </div>

          <div
            v-if="total == 0"
            class="h-40 w-full bg-gray-200 dark:bg-gray-700 flex justify-center items-center"
          >
            <span> لايوجد مراكز تطعيم </span>
          </div>

          <div
            v-else
            v-for="(municipal, personIdx) in municipals_data"
            :key="municipal.id"
            class="hover:bg-gray-100 flex hover:dark:bg-slate-700 text-slate-500 dark:text-slate-400"
            :class="
              personIdx % 2 === 0
                ? 'bg-white dark:bg-slate-800'
                : 'bg-gray-50 dark:bg-slate-800'
            "
          >
            <div
              class="w-1/12 px-6 py-4 whitespace-nowrap text-sm font-medium hidden md:flex items-center"
            >
              {{ personIdx + 1 }}

              <svg
                class="w-6 h-6 mr-2 fill-current"
                :class="
                  municipal.is_training ? 'text-green-500' : 'text-red-500'
                "
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 122.88 94.65"
              >
                <defs></defs>
                <title>training</title>
                <path
                  class="cls-1"
                  d="M21.92,0A10.36,10.36,0,1,1,11.57,10.35,10.35,10.35,0,0,1,21.92,0ZM14.61,22.7l3.68,9.65h.39l1.79-6.18-1-1.05c-.72-1.05-.47-2.25.87-2.47a9.91,9.91,0,0,1,1.45,0,8.37,8.37,0,0,1,1.59.06c1.24.28,1.37,1.48.75,2.44l-1,1.05L25,32.35h.38L28.7,22.7a4.52,4.52,0,0,0,.47.37,6.7,6.7,0,0,1,2.71.85,4.73,4.73,0,0,1,3,2l7.9,10.91,5.63,1.08V16.67h-8a1.86,1.86,0,1,1,0-3.72H77.56V7.52a1.87,1.87,0,0,1,3.73,0V13h39.53a1.86,1.86,0,1,1,0,3.72h-7.93V62.73H121a1.86,1.86,0,0,1,0,3.72H81.55V75a2.56,2.56,0,0,0,.26.2l11.62,11a1.85,1.85,0,1,1-2.54,2.68L81.55,80v8a1.87,1.87,0,0,1-3.73,0V79.68l-9.69,9.21a1.84,1.84,0,0,1-2.62-.07,1.82,1.82,0,0,1,.07-2.61l11.62-11h0a1.71,1.71,0,0,1,.62-.39V66.45H40.37a1.86,1.86,0,0,1,0-3.72h8V47.83L39.1,46A4.88,4.88,0,0,1,36,44.1l-3.93-5.45v.14l-.32,15.78,4,25.24,1.51,8.65c.85,5.78-8,9.21-10.19,1.62L21.91,59.66,16.66,90.57c-1,5.59-10.13,5.64-10.19-1.15l5.79-34.65-.44-18.71a7.9,7.9,0,0,0-1.19,2,12.61,12.61,0,0,0-1,4.58L8.83,53.55C8.39,59.25-.1,59.6,0,53.45c.05-2.76.3-5.54.6-8.37.58-5.42.7-8.78,3.79-14.18a18.3,18.3,0,0,1,4.5-5.21,12.14,12.14,0,0,1,4.88-2.32,7.26,7.26,0,0,0,.84-.67ZM52.13,38.26l10.46-11a2.47,2.47,0,1,1,3.58,3.4L56.33,41a4.89,4.89,0,0,1-4.2,7.46V62.73H109.2V16.67H52.13V38.26Z"
                />
              </svg>
            </div>
            <div
              class="w-7/12 md:w-3/12 px-6 py-4 whitespace-nowrap text-sm truncate"
            >
              {{ municipal.name }}
            </div>
            <div
              class="md:w-2/12 px-6 py-4 whitespace-nowrap text-sm truncate hidden md:block"
            >
              {{ municipal.address }}
            </div>

            <div
              class="md:w-2/12 px-6 py-4 whitespace-nowrap text-sm truncate hidden md:block"
            >
              {{ municipal.storage_address }}
            </div>

            <div
              class="md:w-2/12 px-6 py-4 whitespace-nowrap text-sm truncate hidden md:block"
            >
              {{ municipal.medical_supplies_name }}
            </div>

            <div class="w-5/12 md:w-3/12 px-6 py-4">
              <div class="w-full flex items-center justify-between">
                <button
                  @click="trining_is_done(municipal.id)"
                  v-if="municipal.is_training == false"
                  type="button"
                  title="تم التدريب"
                  class="border px-px"
                >
                  T
                </button>

                <router-link
                  title="المخزن"
                  :to="{
                    name: 'vaccinesMunicipalsStorageByAdmin',
                    params: { id: municipal.id },
                  }"
                  class="mx-2"
                >
                  <svg
                    class="h-6 w-6 stroke-2 stroke-current hover:text-blue-600"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line class="a" x1="2" x2="2" y1="6.225" y2="19.225" />
                    <line class="a" x1="22" x2="22" y1="6.225" y2="19.225" />
                    <path
                      class="a"
                      d="M5.5,16.225H12a0,0,0,0,1,0,0v7a0,0,0,0,1,0,0H5.5a.5.5,0,0,1-.5-.5v-6A.5.5,0,0,1,5.5,16.225Z"
                    />
                    <path
                      class="a"
                      d="M12,16.225h6.5a.5.5,0,0,1,.5.5v6a.5.5,0,0,1-.5.5H12a0,0,0,0,1,0,0v-7A0,0,0,0,1,12,16.225Z"
                    />
                    <path
                      class="a"
                      d="M8.5,9.225h6a.5.5,0,0,1,.5.5v6.5a0,0,0,0,1,0,0H8a0,0,0,0,1,0,0v-6.5A.5.5,0,0,1,8.5,9.225Z"
                    />
                    <path
                      class="a"
                      d="M10,9.225h3a0,0,0,0,1,0,0v2.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-2.5A0,0,0,0,1,10,9.225Z"
                    />
                    <path
                      class="a"
                      d="M7,16.225h3a0,0,0,0,1,0,0v2.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-2.5A0,0,0,0,1,7,16.225Z"
                    />
                    <path
                      class="a"
                      d="M14,16.225h3a0,0,0,0,1,0,0v2.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-2.5A0,0,0,0,1,14,16.225Z"
                    />
                    <path
                      class="a"
                      d="M22.5,6.225a.5.5,0,0,0,.5-.5V4.586a.5.5,0,0,0-.342-.475L12.3.822a1,1,0,0,0-.606,0L1.354,4.117A.5.5,0,0,0,1,4.6V5.725a.5.5,0,0,0,.5.5Z"
                    />
                  </svg>
                </router-link>

                <router-link
                  title="التألف"
                  :to="{
                    name: 'spoiledMunicipalitiesByAdmin',
                    params: { id: municipal.id },
                  }"
                  class="mx-2"
                >
                  <svg
                    class="h-6 w-6 stroke-2 stroke-current hover:text-blue-600"
                    width="256"
                    height="256"
                    viewBox="0 0 256 256"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M96 72V48"
                      stroke-width="16"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M160 208V184"
                      stroke-width="16"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M72 96H48"
                      stroke-width="16"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M208 160H184"
                      stroke-width="16"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M71.0289 128.402L59.7151 139.716C52.2174 147.218 48.0062 157.391 48.0078 167.998C48.0094 178.605 52.2235 188.776 59.7235 196.276C67.2235 203.776 77.3953 207.99 88.0019 207.992C98.6085 207.994 108.781 203.782 116.284 196.285L127.597 184.971M184.97 127.598L196.284 116.285C203.781 108.782 207.993 98.6095 207.991 88.0028C207.989 77.3962 203.775 67.2245 196.275 59.7245C188.775 52.2245 178.604 48.0104 167.997 48.0088C157.39 48.0072 147.217 52.2183 139.715 59.7161L128.401 71.0298"
                      stroke-width="16"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </router-link>

                <router-link
                  title="مراكز التطعيم"
                  :to="{
                    name: 'vaccinationCentersByMunicipalByAdmin',
                    params: { id: municipal.id },
                  }"
                  class="mx-2"
                >
                  <svg
                    class="h-6 w-6 stroke-2 stroke-current hover:text-blue-600"
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="none"
                    viewBox="0 0 48 48"
                  >
                    <mask id="a" fill="#fff">
                      <path d="M23 12L5 12L5 14L23 14V12Z" />
                      <path
                        fill-rule="evenodd"
                        d="M23 16H6V37H5C4.44772 37 4 37.4477 4 38C4 38.5523 4.44772 39 5 39H43C43.5523 39 44 38.5523 44 38C44 37.4477 43.5523 37 43 37H42V16H39V18H40V37H37V25H29V37H8V18H23V16ZM35 37H31V27H35V37Z"
                        clip-rule="evenodd"
                      />
                      <path d="M39 14V12L43 12V14L39 14Z" />
                      <path
                        fill-rule="evenodd"
                        d="M11 32V25H26V32L27 32V34L10 34V32H11ZM13 27H24V32H13V27Z"
                        clip-rule="evenodd"
                      />
                      <path
                        d="M35 10H27C25.8954 10 25 10.8954 25 12V20C25 21.1046 25.8954 22 27 22H35C36.1046 22 37 21.1046 37 20V12C37 10.8954 36.1046 10 35 10Z"
                      />
                    </mask>
                    <path
                      fill="#333"
                      d="M32 14V13H30V14H32ZM29 15H28V17H29V15ZM6 13V18H8V13H6ZM40 13V18H42V13H40ZM30 14V18H32V14H30ZM29 17L33 17V15L29 15V17ZM23 12H25V10L23 10V12ZM5 12L5 10L3 10L3 12L5 12ZM5 14L3 14L3 16H5L5 14ZM23 14V16H25V14H23ZM23 16H25V14H23V16ZM6 16V14H4V16H6ZM6 37V39H8V37H6ZM42 37H40V39H42V37ZM42 16H44V14H42V16ZM39 16V14H37V16H39ZM39 18H37V20H39V18ZM40 18H42V16H40V18ZM40 37V39H42V37H40ZM37 37H35V39H37V37ZM37 25H39V23H37V25ZM29 25V23H27V25H29ZM29 37V39H31V37H29ZM8 37H6V39H8V37ZM8 18V16H6V18H8ZM23 18V20H25V18H23ZM39 12V10L37 10V12H39ZM39 14H37V16H39V14ZM43 12H45V10L43 10V12ZM43 14V16L45 16V14H43ZM31 37H29V39H31V37ZM35 37V39H37V37H35ZM31 27V25H29V27H31ZM35 27H37V25H35V27ZM24 27H26V25H24V27ZM13 27V25H11V27H13ZM24 32V34H26V32H24ZM13 32H11V34H13V32ZM11 32V34H13V32H11ZM11 25V23H9V25H11ZM26 25H28V23H26V25ZM26 32H24V34L26 34L26 32ZM27 32H29V30L27 30L27 32ZM27 34V36H29V34H27ZM10 34H8V36H10V34ZM10 32V30H8V32H10ZM23 10L5 10L5 14L23 14V10ZM3 12L3 14L7 14V12L3 12ZM5 16L23 16V12L5 12L5 16ZM25 14V12H21V14H25ZM5 39H6V35H5V39ZM6 38C6 38.5523 5.55229 39 5 39V35C3.34315 35 2 36.3431 2 38H6ZM5 37C5.55229 37 6 37.4477 6 38H2C2 39.6569 3.34315 41 5 41V37ZM42 38C42 37.4477 42.4477 37 43 37V41C44.6569 41 46 39.6569 46 38H42ZM43 39C42.4477 39 42 38.5523 42 38H46C46 36.3431 44.6569 35 43 35V39ZM42 39H43V35H42V39ZM37 16V18H41V16H37ZM39 20H40V16H39V20ZM38 18V37H42V18H38ZM40 35H37V39H40V35ZM29 35H8V39H29V35ZM10 37V18H6V37H10ZM8 20H23V16H8V20ZM25 18V16H21V18H25ZM37 12V14H41V12H37ZM43 10L39 10V14L43 14V10ZM45 14V12H41V14H45ZM39 16L43 16V12L39 12V16ZM31 39H35V35H31V39ZM29 27V37H33V27H29ZM35 25H31V29H35V25ZM37 37V27H33V37H37ZM24 25H13V29H24V25ZM26 32V27H22V32H26ZM13 34H24V30H13V34ZM11 27V32H15V27H11ZM27 30L26 30L26 34L27 34L27 30ZM29 34V32H25V34H29ZM8 32V34H12V32H8ZM11 30H10V34H11V30ZM27 12H35V8H27V12ZM35 12V20H39V12H35ZM35 20H27V24H35V20ZM27 20V12H23V20H27ZM27 20H23C23 22.2091 24.7909 24 27 24V20ZM35 20V24C37.2091 24 39 22.2091 39 20H35ZM35 12H39C39 9.79086 37.2091 8 35 8V12ZM27 8C24.7909 8 23 9.79086 23 12H27V12V8ZM6 18H23V14H6V18ZM8 37V16H4V37H8ZM43 37H5V41H43V37ZM40 16V37H44V16H40ZM39 18H42V14H39V18ZM39 37V25H35V37H39ZM37 23H29V27H37V23ZM27 25V37H31V25H27ZM9 25V32H13V25H9ZM26 23H11V27H26V23ZM28 32V25H24V32H28ZM10 36L27 36V32L10 32V36Z"
                      mask="url(#a)"
                    />
                  </svg>
                </router-link>

                <router-link
                  title="تعديل"
                  :to="{ name: 'editMunicipal', params: { id: municipal.id } }"
                  class="mx-2"
                >
                  <svg
                    class="h-6 w-6 stroke-current hover:text-blue-600"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L12 15L8 16L9 12L18.5 2.49998Z"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </router-link>

                <button
                  title="حذف"
                  class=""
                  @click="deleteMunicipal(municipal.id)"
                >
                  <svg
                    class="h-6 w-6 stroke-current hover:text-red-600"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.80444 6.50317H5.80444H21.8044"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.80444 6.50317V4.50317C8.80444 3.97274 9.01516 3.46403 9.39023 3.08896C9.7653 2.71389 10.274 2.50317 10.8044 2.50317H14.8044C15.3349 2.50317 15.8436 2.71389 16.2187 3.08896C16.5937 3.46403 16.8044 3.97274 16.8044 4.50317V6.50317M19.8044 6.50317V20.5032C19.8044 21.0336 19.5937 21.5423 19.2187 21.9174C18.8436 22.2925 18.3349 22.5032 17.8044 22.5032H7.80444C7.27401 22.5032 6.7653 22.2925 6.39023 21.9174C6.01516 21.5423 5.80444 21.0336 5.80444 20.5032V6.50317H19.8044Z"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </table>
      </div>
    </div>

    <div
      class="flex justify-end mt-8 mx-auto px-4 sm:px-6 lg:px-8 w-full bg-white relative"
    >
      <pagination
        dir="rtl"
        v-model="page_number"
        :per-page="page_size"
        :records="total"
        @paginate="getMunicipals"
        class="z-10"
      />
    </div>
  </div>
</template>

<script>
import MunicipalsService from "@/services/MunicipalsService";
import MedicalSuppliesService from "@/services/MedicalSuppliesService";

export default {
  computed: {},
  data() {
    return {
      municipals_data: {},
      page_number: 1,
      page_size: 10,
      total: 0,

      filter_medical_suppliers_id: "",
      filter_name: "",

      filter_box: false,
      in_search: false,

      medical_suppliers_data: {},
    };
  },
  created() {
    this.getMunicipals();
    this.MedicalSupplies();
  },
  methods: {
    trining_is_done(id) {
      let loader = this.$loading.show({
        loader: this.loader,
      });

      MunicipalsService.trining_is_done(id)
        .then(() => {
          setTimeout(() => {
            loader.hide();
            this.getMunicipals();
          }, 10);
        })
        .catch((err) => {
          loader.hide();

          this.$swal.fire({
            icon: "error",
            title: "...عذرا",
            text: err.response.data.message,
          });
        });
    },

    MedicalSupplies() {
      let loader = this.$loading.show({
        loader: this.loader,
      });

      MedicalSuppliesService.getMedicalSuppliesWithoutPagination()
        .then((res) => {
          setTimeout(() => {
            loader.hide();
            this.medical_suppliers_data = res.data;
            // this.total = res.data.total;
          }, 10);
        })
        .catch((err) => {
          loader.hide();

          this.$swal.fire({
            icon: "error",
            title: "...عذرا",
            text: err.response.data.message,
          });
        });
    },

    cancel_filter() {
      this.in_search = false;

      this.filter_name = "";
      this.filter_medical_suppliers_id = "";

      this.page_number = 1;
      this.page_size = 10;

      this.getMunicipals();
    },

    do_search() {
      this.page_number = 1;
      this.getMunicipals();
      this.filter_box = !this.filter_box;
      this.in_search = true;
    },

    toggle_filter() {
      this.filter_box = !this.filter_box;
    },

    getMunicipals() {
      let loader = this.$loading.show({
        loader: this.loader,
      });

      MunicipalsService.getMunicipalsSearch(
        this.page_number,
        this.page_size,
        this.filter_name,
        this.filter_medical_suppliers_id
      )
        .then((res) => {
          setTimeout(() => {
            loader.hide();

            this.municipals_data = res.data.list;
            this.total = res.data.total;
          }, 10);
        })
        .catch(() => {
          loader.hide();

          this.municipals_data = {};
          this.total = 0;

          //   this.$swal.fire({
          //     icon: "error",
          //     title: "...عذرا",
          //     text: err.response.data.message,
          //   });
        });
    },
    deleteMunicipal(id) {
      this.$swal
        .fire({
          title: "هل أنت متأكد؟",
          text: "!لن تتمكن من التراجع عن هذا",
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          cancelButtonText: "إلغاء",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "!نعم ، احذفها",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let loader = this.$loading.show({
              loader: this.loader,
            });

            MunicipalsService.deleteMunicipal(id)
              .then((resp) => {
                let i = this.municipals_data.map((item) => item.id).indexOf(id); // find index of your object
                this.municipals_data.splice(i, 1);
                loader.hide();
                this.$swal.fire({
                  text: resp.data.message,
                  icon: "success",
                  confirmButtonText: "حسنا",
                });
              })
              .catch((err) => {
                loader.hide();

                this.$swal.fire({
                  icon: "error",
                  title: "...عذرا",
                  text: err.response.data.errors.name,
                });
              });
          }
        });
    },
  },
};
</script>

<style>
.VuePagination__count {
  display: none;
}

.VuePagination {
  width: 100%;
}

.VuePagination nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination {
  display: flex;
}

.page-link {
  background-color: red;
}

.page-item {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.page-link {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  font-size: 0.75rem;
  /* line-height: 1.25rem; */

  font-weight: 500;
  border-width: 1px;

  --tw-border-opacity: 0;
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));

  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));

  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

.page-link:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(52, 211, 153, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.active {
  background-color: rgba(16, 185, 129);
  color: #fff;
}

.VuePagination nav ul {
  padding-top: 0.3rem;
  padding-bottom: 0.5rem;
  border-radius: 0.375rem;
  overflow: hidden;
}
</style>
